import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, Router, RouterStateSnapshot } from '@angular/router';

import { UserExperienceService } from '@services/user-experience.service';
import { SummitDisposing } from '@summit/models';

@Injectable()
export class LoginGuard extends SummitDisposing implements CanActivate {
  constructor(
    private router: Router,
    private uxService: UserExperienceService
  ) {
    super();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): GuardResult {
    //console.log('LoginGuard canActivate', this.uxService.getUserExperience().isLoggedIn());
    if (this.uxService.getUserExperience().isLoggedIn()) {
      // logged in so return true
      //console.log(this.router);
      //console.log(_route,_state);
      //this.router.navigateByUrl([_route._routeState.url]);
      if (state.url?.startsWith('/login')) {
        if (route.queryParams['returnUrl']) {
          const urlTree = this.router.parseUrl(route.queryParams['returnUrl']);
          return urlTree;
        } else return this.router.parseUrl('/dashboard');
      }
      return true;
    }
    if (
      state.url?.startsWith('/login') ||
      state.url?.startsWith('/signup') ||
      state.url?.startsWith('/accounts/resetpassword')
    ) {
      return true;
    }
    const returnUrl = state.url;
    const newRoute = this.router.parseUrl('/login');
    newRoute.queryParams = { returnUrl: returnUrl };
    return newRoute;
  }
}
